import * as React from "react";
import { connect } from "react-redux";
import { selectTopRewardResourcesIcon } from "../../balancingSelectors/selectBalancingRandomPools";
import { IdRandomPools } from "../../constants/IdRandomPools";
import { IdResource } from "../../constants/IdResource";
import { IdStyles } from "../../less/IdStyles";
import { selectDoghouseInfo } from "../../selectors/selectDoghouseInfo";
import { selectResourceData } from "../../selectors/selectResourceInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { IconWithProgress } from "../generic/icon-with-progress/IconWithProgress";
import { getResourceIcon } from "../generic/icon/getResourceIcon";
import { ResourceRequirement } from "../generic/resource-requirement/ResourceRequirement";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionDoghouseGiveRequest } from "./actionDoghouse";
import { ButtonGiveTreat } from "./ButtonGiveTreat";
import { DogCurrentState } from "./DogCurrentState";
import { DoghouseTopRewards } from "./DoghouseTopRewards";
var _TabDoghousePremium = function (_a) {
    var onGiveTreat = _a.onGiveTreat, premiumTreat = _a.premiumTreat, doghouseInfo = _a.doghouseInfo, onShowAll = _a.onShowAll;
    var topRewards = selectTopRewardResourcesIcon(IdRandomPools.DogPoolPremium);
    var available = doghouseInfo.premiumTreatInventoryCount;
    var progressPercent = available.greaterThan(0) ? 100 : 0;
    return (React.createElement("div", { className: "dog-treat-contents-container" },
        React.createElement(DogCurrentState, null),
        React.createElement("div", { className: "dog-treat-actions-container" },
            React.createElement(DoghouseTopRewards, { onClick: onShowAll, rewards: topRewards }),
            React.createElement("div", { className: "dog-treat-invertory-container" },
                React.createElement(IconWithProgress, { icon: getResourceIcon(premiumTreat), iconStyle: IdStyles.IconLarge, fillClassName: IdStyles.ProgressBarFill, backgroundClassName: IdStyles.ProgressBarBackground, progressPercent: progressPercent, tooltipLoca: IdLoca.dogTreat_premium },
                    React.createElement(ResourceRequirement, { available: available, required: 1 }))),
            React.createElement(ButtonGiveTreat, { onClick: onGiveTreat }))));
};
var mapState = function (state) { return ({
    doghouseInfo: selectDoghouseInfo(state),
    premiumTreat: selectResourceData(state, IdResource.DogtreatPremium),
}); };
var mapDispatch = function (dispatch) { return ({
    onGiveTreat: function () { return dispatch(actionDoghouseGiveRequest()); },
    onShowAll: function () { return dispatch(actionModalOpen(IdModal.ShowAllRewards)); },
}); };
export var TabDoghousePremium = connect(mapState, mapDispatch)(_TabDoghousePremium);



//////////////////
// WEBPACK FOOTER
// ./src/features/doghouse/TabDoghousePremium.tsx
// module id = 2625
// module chunks = 3